import script from "./EditSubgroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSubgroupModal.vue?vue&type=script&setup=true&lang=js"

import "./EditSubgroupModal.vue?vue&type=style&index=0&id=abf27066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abf27066"]])

export default __exports__